import { fetchJSONWithTimeout } from '@noths/polaris-client-utils';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { ContentstackPartner } from './types/PartnerPage.types';

export const PARTNER_CONTENT_API_PATH = `${PUBLIC_API_BASE_PATH}partner-content`;

export const fetchPartnerContentClient = async (
  shortcode: string,
  { preview = false }: { preview?: boolean } = {},
): Promise<ContentstackPartner | null> => {
  const response = await fetchJSONWithTimeout(
    `${PARTNER_CONTENT_API_PATH}/${encodeURIComponent(shortcode)}${preview ? '?preview=true' : ''}`,
  );

  if (!response.ok) {
    return null;
  }

  return response.json();
};
